/*****************************************************************
 *  ZOHO BRIDGE PANEL — EVERY WORD ON THE SCREEN                   *
 *  File: apps/web/src/pages/bridge/bridgeWords.js                 *
 *  What it does: holds every label, hint and message the panel    *
 *  shows, in plain English, in one place.                         *
 *  Reads: nothing.   Writes: nothing.                             *
 *****************************************************************/

/*****************************************************************
 *  TABLE OF CONTENTS                                              *
 *  SECTION 1 — THE WORDS                                          *
 *  SECTION 2 — STATUS AND KIND NAMES                              *
 *****************************************************************/

/*****************************************************************
 *  SECTION 1 — THE WORDS                                          *
 *****************************************************************/

export const BRIDGE_WORDS = {
  pageTitle: 'Zoho bridge',
  pageIntro: 'Prices and customers copied from Zoho wait here. Nothing goes into Butler '
    + 'until you approve it, and nothing is ever sent back to Zoho.',
  notAllowed: 'This page is for owners and admins. Ask an owner to change your role on the HR Team page.',
  loading: 'Loading…',
  loadFailed: 'Could not load this. Check your connection and try again.',
  tryAgain: 'Try again',

  tabInbox: 'Waiting',
  tabPrices: 'Prices',
  tabCustomers: 'Customers',
  tabKeys: 'Keys',
  tabLog: 'Log',

  lastHeard: 'Last delivery from Zoho',
  neverHeard: 'No delivery yet',

  filterStatus: 'Show',
  filterKind: 'Type',
  filterAllKinds: 'Prices and customers',
  emptyPile: 'Nothing here. When the bridge delivers from Zoho, it shows up here.',
  selectAll: 'Select all on screen',
  approveSelected: 'Approve selected',
  selectedCount: 'selected',

  whyLabel: 'Why? (kept with the decision)',
  whyPlaceholder: 'e.g. checked against the price sheet',
  approve: 'Approve',
  reject: 'Reject',
  cancel: 'Cancel',
  confirmApprove: 'Approve and write into Butler',
  confirmReject: 'Reject (kept, nothing written)',
  useOlderAnyway: 'Use this older version anyway',

  whatZohoSays: 'What Zoho says',
  whatChanges: 'What would change in Butler',
  whatChanged: 'What changed in Butler',
  noChanges: 'Nothing would change.',
  brandNew: 'New: Butler does not have this yet.',
  wasBrandNew: 'New: this was not in Butler before.',
  linkedToCustomer: 'Linked to Butler customer',
  looksLike: 'Looks like Butler customer',
  matchedBy: 'matched by',
  noMatch: 'No Butler customer matches. Approving makes a new one.',
  decidedBy: 'Decided',
  failedBecause: 'Could not apply:',
  receivedAt: 'Arrived',

  pricesEmpty: 'No prices approved yet.',
  priceHistory: 'Price history',
  closeHistory: 'Close',
  historyEmpty: 'No changes recorded.',

  linksEmpty: 'No customers linked yet.',
  linkedTo: 'Linked to',
  relink: 'Link to a different customer',
  searchCustomers: 'Search Butler customers by name, email or phone',
  search: 'Search',
  chooseThis: 'Link to this one',
  showOldLinks: 'Show replaced links too',
  replaced: 'Replaced',

  keysIntro: 'A key lets the bridge robot drop records in the waiting pile. '
    + 'A key can never approve anything.',
  keyName: 'Key name',
  keyNamePlaceholder: 'e.g. Zoho bridge on the bot box',
  makeKey: 'Make a key',
  keyShownOnce: 'Copy this key now. It will never be shown again.',
  copyKey: 'Copy key',
  copied: 'Copied',
  copyFailed: 'Could not copy. Select the text and copy it by hand.',
  keysEmpty: 'No keys yet.',
  lastUsed: 'Last used',
  neverUsed: 'Never used',
  revoke: 'Switch off',
  revokeWhy: 'Why switch it off?',
  confirmRevoke: 'Switch this key off',
  keyOff: 'Switched off',
  keyOn: 'Working',
  expires: 'Expires',

  logEmpty: 'Nothing logged yet.',
};

/*****************************************************************
 *  SECTION 2 — STATUS AND KIND NAMES                              *
 *****************************************************************/

// The word a person sees for each status (never the system word alone).
export const STATUS_NAMES = {
  proposed: 'Waiting for you',
  approved: 'Being applied',
  applied: 'In Butler',
  rejected: 'Rejected',
  failed: 'Needs a person',
};

// The word a person sees for each kind of record.
export const KIND_NAMES = {
  books_item: 'Price',
  crm_contact: 'Customer',
};

// How a match was made, in words.
export const MATCH_NAMES = {
  zohoId: 'an earlier link',
  email: 'email',
  phone: 'phone only (check it is the same person)',
  none: 'nothing',
  ambiguous: 'two different customers',
  manual: 'a person, by hand',
};

// The log's action words, in plain English.
export const LOG_ACTION_NAMES = {
  'inbox.receive': 'Delivery from Zoho',
  'inbox.approve': 'Approved',
  'inbox.reject': 'Rejected',
  'link.relink': 'Relinked a customer',
  'key.issue': 'Key made',
  'key.revoke': 'Key switched off',
  no_key: 'Knock with no key',
  bad_key: 'Knock with a bad key',
  wrong_scope: 'Key used on the wrong door',
};
